/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Nav_OrdersInputs */

const en_seller_nav_orders = /** @type {(inputs: Seller_Nav_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders`)
};

const es_seller_nav_orders = /** @type {(inputs: Seller_Nav_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedidos`)
};

const fr_seller_nav_orders = /** @type {(inputs: Seller_Nav_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commandes`)
};

const de_seller_nav_orders = /** @type {(inputs: Seller_Nav_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellungen`)
};

const ja_seller_nav_orders = /** @type {(inputs: Seller_Nav_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注文`)
};

const zh_seller_nav_orders = /** @type {(inputs: Seller_Nav_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订单`)
};

const ar_seller_nav_orders = /** @type {(inputs: Seller_Nav_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الطلبات`)
};

const id_seller_nav_orders = /** @type {(inputs: Seller_Nav_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesanan`)
};

const it_seller_nav_orders = /** @type {(inputs: Seller_Nav_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordini`)
};

const ru_seller_nav_orders = /** @type {(inputs: Seller_Nav_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заказы`)
};

const pt_seller_nav_orders = /** @type {(inputs: Seller_Nav_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedidos`)
};

const ko_seller_nav_orders = /** @type {(inputs: Seller_Nav_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주문 관리`)
};

/**
* | output |
* | --- |
* | "Orders" |
*
* @param {Seller_Nav_OrdersInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_nav_orders = /** @type {((inputs?: Seller_Nav_OrdersInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Nav_OrdersInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_nav_orders(inputs)
	if (locale === "es") return es_seller_nav_orders(inputs)
	if (locale === "fr") return fr_seller_nav_orders(inputs)
	if (locale === "de") return de_seller_nav_orders(inputs)
	if (locale === "ja") return ja_seller_nav_orders(inputs)
	if (locale === "zh") return zh_seller_nav_orders(inputs)
	if (locale === "ar") return ar_seller_nav_orders(inputs)
	if (locale === "id") return id_seller_nav_orders(inputs)
	if (locale === "it") return it_seller_nav_orders(inputs)
	if (locale === "ru") return ru_seller_nav_orders(inputs)
	if (locale === "pt") return pt_seller_nav_orders(inputs)
	return ko_seller_nav_orders(inputs)
});